export const APPTEXT = {
    LOGIN: {
        TITLE: 'API-docs',
        ACTION_LOGIN: 'Ingresar',
        ACTION_PRIVACY_NOTICE: 'Aviso de privacidad'
    },
    PRIVACY_NOTICE: {
        TITLE: 'AVISO DE PRIVACIDAD DE DATOS PERSONALES PARA CLIENTES DE PROCESAR CON ACCESO A SERVICIOS DE CONSULTA DE INFORMACIÓN Y A CURSOS DE CAPACITACIÓN A TRAVÉS DE PLATAFORMAS',
        PRINCIPAL_LIST: 'lista-condiciones',
        ACTION_ACCEPT: 'CONSIENTO Y AUTORIZO'
    },
    HOME: {
        CLOSE_SESSION: 'Cerrar Sesión'
    },
    GENERAL: {
        COPY_LABEL: `Copiar`,
        COPY_SUCCESS: `Texto copiado a papelera`,
        COPY_ERROR: `Se presento un problema al copiar a papelera`,
        PAGINATOR_PAGE: 'Por página:'
    },
    ALERT: {
        TITLES: {
            ERROR: 'Error',
            INFO: 'Información',
            SUCCESS: 'Operación exitosa',
            DEFAULT: 'Aviso'
        },
        OPTIONS: {
            ACCEPT: 'Aceptar',
            CANCEL: 'Cancelar'
        }
    }
}